module.exports = __webpack_public_path__ + "media/src/application/media/logo-white-ef84bebdd7c7ef1b8bc6b34c5004fc57.png";